import type { HTMLAttributes, PropsWithChildren } from 'react';
import cx from 'clsx';
import styles from './AuthenticatedGridTemplate.module.css';

export type AuthenticatedGridTemplateProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement>
>;

/**
 * The main top-level grid template for the authenticated layout
 * meant to contain the tabs, banner, header, and main content
 */
export function AuthenticatedGridTemplate({
  children,
  className,
  ...props
}: AuthenticatedGridTemplateProps) {
  return (
    <div {...props} className={cx(styles.authlayout, className)}>
      {children}
    </div>
  );
}
